import styled, { x } from '@xstyled/styled-components';
import React, { useEffect, useState } from 'react';
import { Flex } from '~/ui/flex/Flex';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { PHONE_NOTIFICATIONS } from '../itemIds';
import PhoneImage from '../phone/iPhone.png';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import { PushNotification } from './PushNotification';

interface Props {
  name?: string;
  content: string;
  picture?: {
    id: string;
    mediaUrl: string;
    name?: string;
    __typename: string;
  };
}

const PhoneBackground = styled.div`
  position: absolute;
  z-index: 2;
  width: 300px;
  height: 580px;
  background-image: url(${PhoneImage});
  pointer-events: none;
`;

const WrapperForChildren = styled.div<{ showLockScreen: boolean }>`
  position: relative;
  width: 270px;
  height: 552px;
  overflow: scroll;
  border-radius: 20px;

  .text-messages {
    width: 280px;
    min-height: 0px;
  }
  .text-messages-chat {
    min-height: 400px;
  }
  .text-messages-header {
    height: 50px;
  }
  .text-messages-footer {
    width: 90%;
  }
  .video-container:first-child {
    position: absolute;
    height: 285px;
    width: 254px;
    height: 547px;
    top: 0;
    left: 0px;
    z-index: 1;
    border-radius: 10px;
  }
  .video-container:nth-child(2) {
    div:nth-child(1) {
      display: none;
    }
  }
`;

const selectorVisualFeedback = (s: TrainingState) =>
  select(s, 'visualFeedback');

const LockScreenBackground = styled.div<{ showLockScreen: boolean }>`
  @keyframes slideToTop {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-100%);
    }
  }

  position: absolute;
  top: 0;

  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #fcf8e9 0%, #fdd15f 100%);
  border-radius: 20px;
  z-index: 1;

  display: flex;
  justify-content: center;

  .phone-time {
    margin-top: 160px;
    font-weight: 700;
    font-size: 45px;
  }

  ${p => {
    const [feedback, setFeedback] = useState(false);
    const { visualFeedback } = useTrainingStore(selectorVisualFeedback);
    useEffect(() => {
      setFeedback(visualFeedback);
    }, []);

    if (!p.showLockScreen) {
      return feedback
        ? 'animation: slideToTop 0.5s forwards;'
        : 'display: none';
    }
  }}
`;

export type PhoneNotificationsDefinition = ItemDefinition<
  typeof PHONE_NOTIFICATIONS,
  Props
>;

export class PhoneNotifications extends Item<
  typeof PHONE_NOTIFICATIONS,
  Props
> {
  protected render({ picture, name, content, children }: RenderProps<Props>) {
    const [showLockScreen, setShowLockScreen] = useState(true);
    const CURRENT_DATE = new Date();
    const TIME = `${CURRENT_DATE.getHours()
      .toString()
      .padStart(2, '0')}:${CURRENT_DATE.getMinutes()
      .toString()
      .padStart(2, '0')}`;

    return (
      <Flex variant="center" className="phone" position="relative" my="md">
        <PhoneBackground className="phone-background" />
        <WrapperForChildren showLockScreen={showLockScreen}>
          {!showLockScreen && <x.div>{children}</x.div>}
          <LockScreenBackground showLockScreen={showLockScreen}>
            <x.span className="phone-time">{TIME}</x.span>
            <PushNotification
              name={name}
              content={content}
              showLockScreen={showLockScreen}
              setShowLockScreen={setShowLockScreen}
              picture={picture}
            />
          </LockScreenBackground>
        </WrapperForChildren>
      </Flex>
    );
  }
}

registry[PHONE_NOTIFICATIONS] = PhoneNotifications;
